// Modül 11-12 - Havayolları - İnteraktif İçerikler

const cabinCrewContentsM11M12Interactive = {
  // ==================== MODÜL 11: TÜRK HAVAYOLLARI ====================
  'CM-M11-U1-L1': {
    lesson_id: 'CM-M11-U1-L1',
    title: 'THY Tarihi ve Vizyonu',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🇹🇷 Türk Hava Yolları - Tarihçe',
      intro: 'Dünyanın en çok ülkeye uçan havayolu!',
      facts: [
        { icon: '📅', title: 'Kuruluş', text: '1933 - Türkiye\'nin bayrak taşıyıcısı' },
        { icon: '🌐', title: 'Network', text: '120+ ülke, 300+ destinasyon' },
        { icon: '⭐', title: 'İttifak', text: 'Star Alliance üyesi (2008)' },
        { icon: '🏆', title: 'Ödül', text: 'Skytrax 4 Yıldızlı Havayolu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY hangi ittifakta?',
        options: [
          { text: 'OneWorld', isCorrect: false, feedback: '❌ OneWorld = British Airways, Qatar' },
          { text: 'Star Alliance', isCorrect: true, feedback: '✅ Star Alliance = Lufthansa, United, THY' },
          { text: 'SkyTeam', isCorrect: false, feedback: '❌ SkyTeam = Air France, KLM' }
        ]
      }
    }
  },

  'CM-M11-U1-L2': {
    lesson_id: 'CM-M11-U1-L2',
    title: 'THY Filo Yapısı',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '✈️ THY Filosu',
      intro: 'Türkiye\'nin en büyük filosu',
      categories: [
        { icon: '🟦', title: 'Dar Gövde', examples: 'Airbus A321, Boeing 737', desc: 'İç hat ve kısa mesafe' },
        { icon: '🟩', title: 'Geniş Gövde', examples: 'A350, B777, B787', desc: 'Uzun mesafe' },
        { icon: '🟨', title: 'Kargo', examples: 'Turkish Cargo', desc: 'Dünya 5. büyük kargo' },
        { icon: '📊', title: 'Toplam', examples: '400+ uçak', desc: 'Sürekli büyüyor' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY\'nin ana hub\'u neresi?',
        options: [
          { text: 'Atatürk Havalimanı', isCorrect: false, feedback: '❌ 2019\'da kapandı!' },
          { text: 'İstanbul Havalimanı (IST)', isCorrect: true, feedback: '✅ 2019\'dan beri ana üs!' },
          { text: 'Sabiha Gökçen', isCorrect: false, feedback: '❌ Sabiha Gökçen ikincil hub' }
        ]
      }
    }
  },

  'CM-M11-U1-L5': {
    lesson_id: 'CM-M11-U1-L5',
    title: '🎮 THY Quiz',
    type: 'quiz',
    duration: 4,
    xp: 50,
    quiz: {
      questions: [
        { q: 'THY hangi ittifakta?', options: ['OneWorld', 'Star Alliance', 'SkyTeam', 'Yok'], correct: 1 },
        { q: 'THY kuruluş yılı?', options: ['1923', '1933', '1953', '2003'], correct: 1 },
        { q: 'THY kaç ülkeye uçuyor?', options: ['50', '80', '120+', '200'], correct: 2 },
        { q: 'Ana hub?', options: ['Atatürk', 'İstanbul (IST)', 'Ankara', 'Antalya'], correct: 1 },
        { q: 'Turkish Cargo dünya sıralaması?', options: ['1.', '3.', '5.', '10.'], correct: 2 }
      ]
    }
  },

  'CM-M11-U2-L1': {
    lesson_id: 'CM-M11-U2-L1',
    title: 'Pegasus Tarihi',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🟨 Pegasus Airlines',
      intro: 'Türkiye\'nin en büyük low-cost havayolu',
      facts: [
        { icon: '📅', title: 'Kuruluş', text: '1990 - Özelleştirildi 2005' },
        { icon: '💰', title: 'Model', text: 'Low-cost carrier (LCC)' },
        { icon: '✈️', title: 'Filo', text: '100+ Airbus (A320 ailesi)' },
        { icon: '🏠', title: 'Hub', text: 'Sabiha Gökçen (SAW)' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Pegasus hangi tür havayolu?',
        options: [
          { text: 'Bayrak taşıyıcı', isCorrect: false, feedback: '❌ Bayrak taşıyıcı = THY' },
          { text: 'Low-cost (düşük maliyet)', isCorrect: true, feedback: '✅ LCC = Ucuz bilet!' },
          { text: 'Charter', isCorrect: false, feedback: '❌ Charter = Tur operasyonu' }
        ]
      }
    }
  },

  'CM-M11-U3-L1': {
    lesson_id: 'CM-M11-U3-L1',
    title: 'SunExpress Hikayesi',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '☀️ SunExpress',
      intro: 'THY-Lufthansa ortak girişimi',
      facts: [
        { icon: '🤝', title: 'Ortaklık', text: '%50 THY, %50 Lufthansa' },
        { icon: '📅', title: 'Kuruluş', text: '1989 - Antalya merkezli' },
        { icon: '🏖️', title: 'Odak', text: 'Tatil destinasyonları' },
        { icon: '✈️', title: 'Filo', text: 'Boeing 737 MAX ailesi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'SunExpress kimlerle ortak?',
        options: [
          { text: 'THY + Emirates', isCorrect: false, feedback: '❌ Emirates Körfez havayolu' },
          { text: 'THY + Lufthansa', isCorrect: true, feedback: '✅ Alman-Türk ortaklığı!' },
          { text: 'Pegasus + Ryanair', isCorrect: false, feedback: '❌ Bunlar rakip LCC\'ler' }
        ]
      }
    }
  },

  'CM-M12-U1-L3': {
    lesson_id: 'CM-M12-U1-L3',
    title: 'Emirates Özellikleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🏜️ Emirates - Dubai\'nin Gururu',
      intro: 'Dünyanın en büyük uluslararası havayolu',
      facts: [
        { icon: '🏠', title: 'DXB Hub', text: 'Dubai merkez' },
        { icon: '✈️', title: 'A380 Lideri', text: 'En büyük A380 filosu' },
        { icon: '🌍', title: 'Global', text: '150+ destinasyon' },
        { icon: '⭐', title: 'Premium', text: 'Lüks servis' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Emirates\'in en çok sahip olduğu uçak?',
        options: [
          { text: 'B737', isCorrect: false, feedback: '❌ Dar gövde!' },
          { text: 'A380', isCorrect: true, feedback: '✅ En büyük A380 filosu!' },
          { text: 'A320', isCorrect: false, feedback: '❌ Dar gövde!' }
        ]
      }
    }
  },

  'CM-M12-U2-L2': {
    lesson_id: 'CM-M12-U2-L2',
    title: 'Singapore Airlines',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🦁 Singapore Airlines',
      intro: 'Asya\'nın en prestijli havayolu',
      facts: [
        { icon: '🏠', title: 'SIN Hub', text: 'Changi Havalimanı' },
        { icon: '👗', title: 'Singapore Girl', text: 'İkonik kabin memuru' },
        { icon: '⭐', title: '5 Yıldız', text: 'Skytrax 5 yıldız' },
        { icon: '✈️', title: 'A350/B787', text: 'Modern filo' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Singapore Airlines\'ın simgesi?',
        options: [
          { text: 'Aslan', isCorrect: false, feedback: '❌ Logo değil!' },
          { text: 'Singapore Girl', isCorrect: true, feedback: '✅ Sarong kebaya giyen kabin memuru!' },
          { text: 'Kuş', isCorrect: false, feedback: '❌ Logo değil!' }
        ]
      }
    }
  },

  'CM-M12-U2-L3': {
    lesson_id: 'CM-M12-U2-L3',
    title: 'Cathay Pacific',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🐉 Cathay Pacific',
      intro: 'Hong Kong\'un bayrak taşıyıcısı',
      facts: [
        { icon: '🏠', title: 'HKG Hub', text: 'Hong Kong merkez' },
        { icon: '🌏', title: 'Asya-Pasifik', text: 'Güçlü Asya ağı' },
        { icon: '⭐', title: 'oneworld', text: 'İttifak üyesi' },
        { icon: '✈️', title: 'A350', text: 'Modern uzun menzil' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Cathay Pacific hangi ittifakta?',
        options: [
          { text: 'Star Alliance', isCorrect: false, feedback: '❌ THY orada!' },
          { text: 'oneworld', isCorrect: true, feedback: '✅ BA, Qatar ile birlikte!' },
          { text: 'SkyTeam', isCorrect: false, feedback: '❌ Air France orada!' }
        ]
      }
    }
  },

  'CM-M12-U2-L4': {
    lesson_id: 'CM-M12-U2-L4',
    title: '⚡ Asya Havayolları Quiz',
    type: 'quiz',
    duration: 5,
    xp: 45,
    quiz: {
      questions: [
        { q: 'Singapore Girl nedir?', options: ['Logo', 'Kabin memuru simgesi', 'Uçak', 'Rota'], correct: 1 },
        { q: 'Cathay Pacific hub?', options: ['SIN', 'HKG', 'BKK', 'KUL'], correct: 1 },
        { q: 'En büyük A380 filosu?', options: ['Singapore', 'Emirates', 'Qatar', 'Etihad'], correct: 1 },
        { q: 'Cathay ittifakı?', options: ['Star', 'oneworld', 'SkyTeam', 'Yok'], correct: 1 }
      ]
    }
  },

  'CM-M12-U3-L1': {
    lesson_id: 'CM-M12-U3-L1',
    title: 'Avrupa Havayolları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🇪🇺 Avrupa\'nın Devleri',
      intro: 'Avrupa\'nın büyük havayolu grupları',
      facts: [
        { icon: '🇩🇪', title: 'Lufthansa', text: 'Almanya - FRA hub' },
        { icon: '🇫🇷', title: 'Air France', text: 'Fransa - CDG hub' },
        { icon: '🇬🇧', title: 'British Airways', text: 'İngiltere - LHR hub' },
        { icon: '🇳🇱', title: 'KLM', text: 'Hollanda - AMS hub' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Lufthansa\'nın hub\'ı?',
        options: [
          { text: 'Berlin', isCorrect: false, feedback: '❌ Frankfurt!' },
          { text: 'Frankfurt (FRA)', isCorrect: true, feedback: '✅ Avrupa\'nın en büyük hub\'larından!' },
          { text: 'Münih', isCorrect: false, feedback: '❌ İkincil hub!' }
        ]
      }
    }
  },

  'CM-M12-U3-L2': {
    lesson_id: 'CM-M12-U3-L2',
    title: 'Havayolu Grupları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🏢 Havayolu Grupları',
      intro: 'Birçok havayolu büyük gruplara ait',
      facts: [
        { icon: '🇩🇪', title: 'Lufthansa Group', text: 'Swiss, Austrian, Brussels' },
        { icon: '🇫🇷', title: 'Air France-KLM', text: 'Air France + KLM' },
        { icon: '🇪🇸', title: 'IAG', text: 'BA, Iberia, Vueling' },
        { icon: '🇮🇹', title: 'ITA Airways', text: 'Eski Alitalia' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Swiss hangi gruba ait?',
        options: [
          { text: 'Air France-KLM', isCorrect: false, feedback: '❌ KLM orada!' },
          { text: 'Lufthansa Group', isCorrect: true, feedback: '✅ Lufthansa\'nın yan kuruluşu!' },
          { text: 'IAG', isCorrect: false, feedback: '❌ BA orada!' }
        ]
      }
    }
  },

  'CM-M12-U3-L3': {
    lesson_id: 'CM-M12-U3-L3',
    title: '🎮 Avrupa Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      instruction: 'Havayolunu hub\'ı ile eşleştir',
      pairs: [
        { id: 1, left: 'Lufthansa', right: 'FRA (Frankfurt)' },
        { id: 2, left: 'Air France', right: 'CDG (Paris)' },
        { id: 3, left: 'British Airways', right: 'LHR (Londra)' },
        { id: 4, left: 'KLM', right: 'AMS (Amsterdam)' }
      ]
    }
  },

  'CM-M12-U4-L1': {
    lesson_id: 'CM-M12-U4-L1',
    title: 'Amerikan Havayolları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🇺🇸 ABD Havayolları',
      intro: 'Dünyanın en büyük iç hat pazarı',
      facts: [
        { icon: '🇺🇸', title: 'American', text: 'Dünyanın en büyüğü (filo)' },
        { icon: '🇺🇸', title: 'Delta', text: 'ATL hub - En yoğun' },
        { icon: '🇺🇸', title: 'United', text: 'Star Alliance' },
        { icon: '🇺🇸', title: 'Southwest', text: 'LCC lideri' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Dünyanın en yoğun havalimanı?',
        options: [
          { text: 'JFK', isCorrect: false, feedback: '❌ New York büyük ama 1 numara değil!' },
          { text: 'ATL (Atlanta)', isCorrect: true, feedback: '✅ Hartsfield-Jackson en yoğun!' },
          { text: 'LAX', isCorrect: false, feedback: '❌ Los Angeles büyük ama 1 değil!' }
        ]
      }
    }
  },

  'CM-M12-U4-L2': {
    lesson_id: 'CM-M12-U4-L2',
    title: '⚡ Dünya Havayolu Quiz',
    type: 'quiz',
    duration: 5,
    xp: 50,
    quiz: {
      questions: [
        { q: 'En yoğun havalimanı?', options: ['JFK', 'ATL', 'LHR', 'DXB'], correct: 1 },
        { q: 'Lufthansa Group\'ta kim var?', options: ['KLM', 'Swiss', 'BA', 'AF'], correct: 1 },
        { q: 'Singapore Girl nedir?', options: ['Logo', 'Kabin memuru', 'Uçak', 'Rota'], correct: 1 },
        { q: 'Emirates hub?', options: ['DOH', 'DXB', 'AUH', 'RUH'], correct: 1 }
      ]
    }
  },

  'CM-M12-U5-L3': {
    lesson_id: 'CM-M12-U5-L3',
    title: '🎓 Dünya Havayolları Final',
    type: 'exam',
    duration: 10,
    xp: 100,
    exam: {
      questions: [
        { q: 'Emirates hub?', options: ['DOH', 'DXB', 'AUH', 'RUH'], correct: 1 },
        { q: 'Singapore Girl?', options: ['Logo', 'Kabin memuru', 'Pilot', 'CEO'], correct: 1 },
        { q: 'Lufthansa ittifakı?', options: ['oneworld', 'Star Alliance', 'SkyTeam', 'Yok'], correct: 1 },
        { q: 'ATL hangi şehir?', options: ['Austin', 'Atlanta', 'Adelaide', 'Ankara'], correct: 1 },
        { q: 'KLM hangi ülke?', options: ['Belçika', 'Hollanda', 'Danimarka', 'İsveç'], correct: 1 },
        { q: 'En büyük A380 filosu?', options: ['Singapore', 'Emirates', 'Qatar', 'BA'], correct: 1 },
        { q: 'IAG\'de kim var?', options: ['Lufthansa', 'BA', 'KLM', 'AF'], correct: 1 },
        { q: 'Cathay Pacific hub?', options: ['SIN', 'HKG', 'BKK', 'TPE'], correct: 1 }
      ]
    }
  },

  // ==================== M11 EKSİK DERSLER ====================
  'CM-M11-U1-L3': {
    lesson_id: 'CM-M11-U1-L3',
    title: 'THY Filo Yapısı',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '✈️ THY Filosu',
      intro: 'Avrupa\'nın en büyük filolarından biri!',
      facts: [
        { icon: '🔢', title: '400+ Uçak', text: 'Büyük ve modern filo' },
        { icon: '✈️', title: 'A350', text: 'En yeni uzun menzil' },
        { icon: '✈️', title: 'B787', text: 'Dreamliner serisi' },
        { icon: '✈️', title: 'A321neo', text: 'Dar gövde yeni nesil' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY\'nin en yeni uzun menzil uçağı?',
        options: [
          { text: 'B737', isCorrect: false, feedback: '❌ B737 dar gövde!' },
          { text: 'A350', isCorrect: true, feedback: '✅ A350 yeni nesil uzun menzil!' },
          { text: 'A320', isCorrect: false, feedback: '❌ A320 dar gövde!' }
        ]
      }
    }
  },

  'CM-M11-U1-L4': {
    lesson_id: 'CM-M11-U1-L4',
    title: 'THY Destinasyonları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🌍 THY Nereye Uçuyor?',
      intro: 'En fazla ülkeye uçan havayolu!',
      facts: [
        { icon: '🌍', title: '120+ Ülke', text: 'Dünya lideri' },
        { icon: '🏙️', title: '340+ Şehir', text: 'Geniş ağ' },
        { icon: '🌏', title: 'Afrika Lideri', text: 'En çok Afrika noktası' },
        { icon: '🛫', title: 'IST Hub', text: 'Stratejik konum' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY kaç ülkeye uçuyor?',
        options: [
          { text: '50+', isCorrect: false, feedback: '❌ Daha fazla!' },
          { text: '80+', isCorrect: false, feedback: '❌ Daha fazla!' },
          { text: '120+', isCorrect: true, feedback: '✅ En fazla ülkeye uçan!' }
        ]
      }
    }
  },

  'CM-M11-U2-L2': {
    lesson_id: 'CM-M11-U2-L2',
    title: 'Pegasus Özellikleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🟢 Pegasus Havayolları',
      intro: 'Türkiye\'nin düşük maliyetli devi',
      facts: [
        { icon: '💰', title: 'LCC Model', text: 'Low Cost Carrier' },
        { icon: '🏠', title: 'SAW Hub', text: 'Sabiha Gökçen merkez' },
        { icon: '✈️', title: 'A320neo', text: 'Modern Airbus filosu' },
        { icon: '🌍', title: 'Avrupa', text: 'Avrupa ağı güçlü' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Pegasus ne tür havayolu?',
        options: [
          { text: 'Full service', isCorrect: false, feedback: '❌ THY full service!' },
          { text: 'Düşük maliyetli (LCC)', isCorrect: true, feedback: '✅ Low Cost Carrier!' },
          { text: 'Charter', isCorrect: false, feedback: '❌ Tarifeli uçuşlar!' }
        ]
      }
    }
  },

  'CM-M11-U2-L3': {
    lesson_id: 'CM-M11-U2-L3',
    title: 'SunExpress',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '☀️ SunExpress',
      intro: 'THY ve Lufthansa ortak girişimi',
      facts: [
        { icon: '🤝', title: 'Ortaklık', text: 'THY + Lufthansa' },
        { icon: '🏖️', title: 'Turizm', text: 'Tatil uçuşları' },
        { icon: '🏠', title: 'AYT Hub', text: 'Antalya merkez' },
        { icon: '🌍', title: 'Almanya', text: 'TR-DE hattı güçlü' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'SunExpress\'in ortakları?',
        options: [
          { text: 'THY + Emirates', isCorrect: false, feedback: '❌ Lufthansa ortağı!' },
          { text: 'THY + Lufthansa', isCorrect: true, feedback: '✅ İki büyük ortaklık!' },
          { text: 'Pegasus + Ryanair', isCorrect: false, feedback: '❌ Yanlış!' }
        ]
      }
    }
  },

  'CM-M11-U2-L4': {
    lesson_id: 'CM-M11-U2-L4',
    title: '⚡ Türk Havayolları Quiz',
    type: 'quiz',
    duration: 5,
    xp: 45,
    quiz: {
      questions: [
        { q: 'THY ana hub?', options: ['SAW', 'IST', 'ESB', 'AYT'], correct: 1 },
        { q: 'Pegasus merkezi?', options: ['IST', 'SAW', 'AYT', 'ESB'], correct: 1 },
        { q: 'SunExpress merkezi?', options: ['IST', 'SAW', 'AYT', 'ESB'], correct: 2 },
        { q: 'LCC ne demek?', options: ['Large', 'Low Cost', 'Long', 'Luxury'], correct: 1 }
      ]
    }
  },

  'CM-M11-U3-L2': {
    lesson_id: 'CM-M11-U3-L2',
    title: 'AnadoluJet',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🔵 AnadoluJet',
      intro: 'THY\'nin iç hat markası',
      facts: [
        { icon: '🏠', title: 'ESB Hub', text: 'Ankara merkez' },
        { icon: '🇹🇷', title: 'İç Hat', text: 'Anadolu şehirleri' },
        { icon: '✈️', title: 'THY Filosu', text: 'Aynı uçaklar' },
        { icon: '💰', title: 'Ekonomik', text: 'Uygun fiyat' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'AnadoluJet\'in ana hub\'u?',
        options: [
          { text: 'IST', isCorrect: false, feedback: '❌ THY IST!' },
          { text: 'ESB (Ankara)', isCorrect: true, feedback: '✅ Esenboğa merkez!' },
          { text: 'AYT', isCorrect: false, feedback: '❌ SunExpress AYT!' }
        ]
      }
    }
  },

  'CM-M11-U3-L3': {
    lesson_id: 'CM-M11-U3-L3',
    title: '🎮 Hub Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      instruction: 'Havayolunu hub\'ı ile eşleştir',
      pairs: [
        { id: 1, left: 'THY', right: 'IST' },
        { id: 2, left: 'Pegasus', right: 'SAW' },
        { id: 3, left: 'SunExpress', right: 'AYT' },
        { id: 4, left: 'AnadoluJet', right: 'ESB' }
      ]
    }
  },

  'CM-M11-U4-L1': {
    lesson_id: 'CM-M11-U4-L1',
    title: 'Türkiye Havalimanları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🛫 Türkiye Havalimanları',
      intro: 'Türkiye\'nin ana havalimanları',
      facts: [
        { icon: 'IST', title: 'İstanbul', text: '2019 açıldı, mega hub' },
        { icon: 'SAW', title: 'Sabiha Gökçen', text: 'Anadolu yakası' },
        { icon: 'ESB', title: 'Ankara Esenboğa', text: 'Başkent' },
        { icon: 'AYT', title: 'Antalya', text: 'Turizm merkezi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İstanbul Havalimanı kaç yılında açıldı?',
        options: [
          { text: '2015', isCorrect: false, feedback: '❌ Daha yeni!' },
          { text: '2019', isCorrect: true, feedback: '✅ 2019\'da hizmete girdi!' },
          { text: '2022', isCorrect: false, feedback: '❌ Daha eski!' }
        ]
      }
    }
  },

  'CM-M11-U4-L2': {
    lesson_id: 'CM-M11-U4-L2',
    title: 'IATA Kodları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🔤 IATA Havaalanı Kodları',
      intro: '3 harfli uluslararası kodlar',
      facts: [
        { icon: 'IST', title: 'İstanbul', text: 'Yeni havalimanı' },
        { icon: 'SAW', title: 'Sabiha Gökçen', text: 'Anadolu yakası' },
        { icon: 'ADB', title: 'İzmir', text: 'Adnan Menderes' },
        { icon: 'DLM', title: 'Dalaman', text: 'Muğla bölgesi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'ADB hangi havalimanı?',
        options: [
          { text: 'Ankara', isCorrect: false, feedback: '❌ Ankara = ESB!' },
          { text: 'İzmir', isCorrect: true, feedback: '✅ Adnan Menderes!' },
          { text: 'Antalya', isCorrect: false, feedback: '❌ Antalya = AYT!' }
        ]
      }
    }
  },

  'CM-M11-U4-L3': {
    lesson_id: 'CM-M11-U4-L3',
    title: '⚡ Kod Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 6,
      questions: [
        { q: 'İstanbul Havalimanı kodu?', options: ['SAW', 'IST', 'ISL', 'IGA'], correct: 1 },
        { q: 'Ankara kodu?', options: ['ANK', 'ESB', 'AKR', 'TRK'], correct: 1 },
        { q: 'Antalya kodu?', options: ['ANT', 'AYT', 'ANA', 'ALY'], correct: 1 },
        { q: 'İzmir kodu?', options: ['IZM', 'ADB', 'IZR', 'MIR'], correct: 1 },
        { q: 'THY kodu?', options: ['TK', 'TH', 'THY', 'TUR'], correct: 0 },
        { q: 'Pegasus kodu?', options: ['PG', 'PC', 'PEG', 'FLY'], correct: 1 }
      ]
    }
  },

  'CM-M11-U5-L1': {
    lesson_id: 'CM-M11-U5-L1',
    title: 'Star Alliance',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '⭐ Star Alliance',
      intro: 'THY\'nin ittifakı - En büyük havayolu ittifakı',
      facts: [
        { icon: '🌟', title: 'Kuruluş', text: '1997 - İlk ittifak' },
        { icon: '✈️', title: 'Üye', text: '26 havayolu' },
        { icon: '🌍', title: 'Ağ', text: '1300+ destinasyon' },
        { icon: '🇹🇷', title: 'THY', text: '2008\'den üye' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY hangi ittifakta?',
        options: [
          { text: 'oneworld', isCorrect: false, feedback: '❌ BA, Qatar orada!' },
          { text: 'Star Alliance', isCorrect: true, feedback: '✅ Lufthansa ile birlikte!' },
          { text: 'SkyTeam', isCorrect: false, feedback: '❌ Air France orada!' }
        ]
      }
    }
  },

  'CM-M11-U5-L2': {
    lesson_id: 'CM-M11-U5-L2',
    title: 'İttifak Üyeleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '✈️ Star Alliance Üyeleri',
      intro: 'Önemli Star Alliance havayolları',
      facts: [
        { icon: '🇩🇪', title: 'Lufthansa', text: 'Kurucu üye' },
        { icon: '🇺🇸', title: 'United', text: 'ABD\'nin en büyüğü' },
        { icon: '🇸🇬', title: 'Singapore', text: 'Asya lideri' },
        { icon: '🇨🇦', title: 'Air Canada', text: 'Kanada bayrağı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Hangi havayolu Star Alliance değil?',
        options: [
          { text: 'Lufthansa', isCorrect: false, feedback: '❌ Star Alliance kurucu!' },
          { text: 'Emirates', isCorrect: true, feedback: '✅ Emirates hiçbir ittifakta değil!' },
          { text: 'THY', isCorrect: false, feedback: '❌ THY Star Alliance üyesi!' }
        ]
      }
    }
  },

  'CM-M11-U5-L3': {
    lesson_id: 'CM-M11-U5-L3',
    title: '🎮 İttifak Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      instruction: 'Havayolunu ittifakı ile eşleştir',
      pairs: [
        { id: 1, left: 'THY', right: 'Star Alliance' },
        { id: 2, left: 'Qatar Airways', right: 'oneworld' },
        { id: 3, left: 'Air France', right: 'SkyTeam' },
        { id: 4, left: 'Emirates', right: 'Bağımsız' }
      ]
    }
  },

  'CM-M11-U6-L2': {
    lesson_id: 'CM-M11-U6-L2',
    title: '🎓 Türk Havacılık Final',
    type: 'exam',
    duration: 10,
    xp: 100,
    exam: {
      questions: [
        { q: 'THY kaç ülkeye uçuyor?', options: ['50+', '80+', '120+', '150+'], correct: 2 },
        { q: 'Pegasus hub?', options: ['IST', 'SAW', 'ESB', 'AYT'], correct: 1 },
        { q: 'SunExpress ortakları?', options: ['THY+Emirates', 'THY+Lufthansa', 'Pegasus+BA', 'AJ+QR'], correct: 1 },
        { q: 'THY ittifakı?', options: ['oneworld', 'Star Alliance', 'SkyTeam', 'Bağımsız'], correct: 1 },
        { q: 'İstanbul kodu?', options: ['SAW', 'IST', 'ISL', 'IGA'], correct: 1 },
        { q: 'AnadoluJet hub?', options: ['IST', 'SAW', 'ESB', 'AYT'], correct: 2 },
        { q: 'A350 ne tür?', options: ['Dar gövde', 'Geniş gövde', 'Kargo', 'Özel'], correct: 1 },
        { q: 'LCC ne demek?', options: ['Large', 'Low Cost', 'Long', 'Luxury'], correct: 1 }
      ]
    }
  },

  // ==================== MGA HAVAYOLLARI ====================
  'CM-M11-U7-L1': {
    lesson_id: 'CM-M11-U7-L1',
    title: 'MGA Havayolları Hakkında',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '✈️ MGA Havayolları (Mavi Gök Airlines)',
      intro: 'Türkiye\'nin yeni nesil charter havayolu şirketi!',
      facts: [
        { icon: '📅', title: 'Kuruluş', text: '2022 - Genç ve dinamik havayolu' },
        { icon: '🏠', title: 'Hub', text: 'Antalya (AYT) - Turizm merkezi' },
        { icon: '✈️', title: 'Filo', text: 'Boeing 737-900ER uçakları' },
        { icon: '⭐', title: 'Sertifikalar', text: 'IATA üyesi, IOSA sertifikalı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'MGA\'nın tam adı nedir?',
        options: [
          { text: 'Mediterranean Gulf Airlines', isCorrect: false, feedback: '❌ Hayır, Türkçe bir isim!' },
          { text: 'Mavi Gök Airlines', isCorrect: true, feedback: '✅ Doğru! Mavi Gök = Blue Sky' },
          { text: 'Modern Global Airlines', isCorrect: false, feedback: '❌ Hayır!' }
        ]
      }
    }
  },

  'CM-M11-U7-L2': {
    lesson_id: 'CM-M11-U7-L2',
    title: 'MGA Havayolları',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '🌟 MGA Hizmetleri ve Değerleri',
      intro: 'Konforlu, güvenli ve dostça hizmet!',
      facts: [
        { icon: '🛫', title: 'Charter Uçuşlar', text: 'Özel gruplar ve organizasyonlar için' },
        { icon: '🔧', title: 'Wet Lease', text: 'Dünya çapında operasyon desteği' },
        { icon: '🛠️', title: 'MGA Technic', text: 'Part-145 yetkili bakım merkezi' },
        { icon: '🌍', title: 'Destinasyonlar', text: 'Antalya, Bodrum, Londra ve daha fazlası' }
      ],
      highlight: {
        title: '🎯 MGA Değerleri',
        items: [
          '✈️ Konforlu ve keyifli uçuş deneyimi',
          '🛡️ Güvenlik ve emniyet öncelikli',
          '😊 Dostça ve güler yüzlü hizmet',
          '🌐 Dünyayı keşfetme fırsatı'
        ]
      },
      challenge: {
        type: 'multipleChoice',
        question: 'MGA\'nın ana hub\'u neresi?',
        options: [
          { text: 'İstanbul (IST)', isCorrect: false, feedback: '❌ THY\'nin hub\'u!' },
          { text: 'Antalya (AYT)', isCorrect: true, feedback: '✅ Doğru! Turizm merkezi!' },
          { text: 'Ankara (ESB)', isCorrect: false, feedback: '❌ AnadoluJet hub\'u!' }
        ]
      }
    }
  },

  'CM-M11-U7-L3': {
    lesson_id: 'CM-M11-U7-L3',
    title: '🎮 MGA Havayolları Quiz',
    type: 'quiz',
    duration: 5,
    xp: 30,
    quiz: {
      questions: [
        { q: 'MGA ne zaman kuruldu?', options: ['2015', '2018', '2022', '2024'], correct: 2 },
        { q: 'MGA\'nın tam adı?', options: ['Metro Global', 'Mavi Gök', 'Mediterranean', 'Modern Gulf'], correct: 1 },
        { q: 'MGA hangi uçak tipini kullanıyor?', options: ['A320', 'A350', 'B737-900ER', 'B787'], correct: 2 },
        { q: 'MGA\'nın hub\'u?', options: ['IST', 'SAW', 'AYT', 'ESB'], correct: 2 },
        { q: 'MGA hangi sertifikaya sahip?', options: ['ETOPS', 'IOSA', 'CAT III', 'RVSM'], correct: 1 },
        { q: 'MGA hangi hizmeti sunmaz?', options: ['Charter', 'Wet Lease', 'Teknik bakım', 'Uzay turizmi'], correct: 3 }
      ]
    }
  }
};

export default cabinCrewContentsM11M12Interactive;
